import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { headerReducers } from '@zocdoc-frontend-common/components-header/reducer';
import { signInFormReducer } from '@zocdoc-frontend-common/components-sign-in-form';
import { AB_ROOT_KEY, abReducer } from '@zocdoc-frontend-common/utils-ab';
import { SERVER_KEY } from '../server/constants';
import { reducer as serverReducer } from '../server/reducer';
import { THEME_KEY } from '../theme/constants';
import { reducer as themeReducer } from '../theme/reducer';

const STORYBOOK_RESET = '@@storybook/STORYBOOK_RESET';

export default function createRootReducer(reducers = {}, isStorybook = false) {
    const bookingReducer = combineReducers({
        routing: routerReducer,
        signInForm: signInFormReducer,
        [THEME_KEY]: themeReducer,
        [SERVER_KEY]: serverReducer,
        [AB_ROOT_KEY]: abReducer,
        ...headerReducers,
        ...reducers,
    });
    if (isStorybook) {
        return (state, action) => {
            if (action.type === STORYBOOK_RESET) {
                state = undefined;
            }
            return bookingReducer(state, action);
        };
    }

    return bookingReducer;
}
